<div class="content" [style.align-items]="align()">
  <div class="title">
    @if (identifierColor(); as color) {
      <div class="identifier {{ color }}"></div>
    }

    <ng-content select="[titleIcon]"></ng-content>

    <h6
      [class.f-link]="clickable()"
      [attr.tabindex]="clickable() ? 0 : null"
      (click)="clickable() && linkClick.emit()"
      (keydown.space)="clickable() && linkClick.emit()"
    >
      <ng-content></ng-content>
    </h6>
  </div>

  <span class="count f-label-m f-muted">{{ count() }}</span>

  <span class="subheading f-muted">
    <ng-content select="[subheading]"></ng-content>
  </span>
</div>

<div class="actions">
  <ng-content select="[actions]"></ng-content>
</div>
